/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { KycFormSnapshotDto } from '../../models/kyc-form-snapshot-dto';

export interface GetFormVersion$Params {
  id: string;
  snapshotId: string;
}

export function getFormVersion(http: HttpClient, rootUrl: string, params: GetFormVersion$Params, context?: HttpContext): Observable<StrictHttpResponse<KycFormSnapshotDto>> {
  const rb = new RequestBuilder(rootUrl, getFormVersion.PATH, 'get');
  if (params) {
    rb.path('id', params.id, {});
    rb.path('snapshotId', params.snapshotId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<KycFormSnapshotDto>;
    })
  );
}

getFormVersion.PATH = '/kyc/processes/{id}/form-versions/{snapshotId}';
